import LockIcon from '@mui/icons-material/Lock';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

const StyledDivider = styled(Divider)`
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

type LockProps = {
  divider?: boolean;
  marginRight?: boolean;
  gray?: boolean;
};

export const Lock = ({ divider, marginRight, gray }: LockProps) => {
  return (
    <>
      <LockIcon
        data-test="locked-icon"
        sx={theme => ({
          color: gray ? theme.palette.text.secondary : 'inherit',
          fontSize: 16,
          marginRight: marginRight ? 1 : 0,
          verticalAlign: 'sub',
        })}
      />
      {divider && <StyledDivider orientation="vertical" />}
    </>
  );
};
